import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { getCookie } from "../../lib/fbCookies";
import { waUrl } from "../../config/bdk";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initialState = {
  nombre: "",
  whatsapp: "",
  ciudad: "",
  negocio: "",
  correo: "",
};

const inputCls =
  "w-full bg-transparent text-[13px] text-white px-3.5 py-3 focus:outline-none transition-all placeholder:text-[#8a8b93]";

const Field = ({ label, optional, children }) => (
  <div>
    <label className="block text-[11px] font-bold text-white mb-1.5">
      {label}
      {optional ? (
        <span className="text-[#8a8b93] font-normal"> — opcional</span>
      ) : (
        <span style={{ color: "var(--red)" }}> *</span>
      )}
    </label>
    {children}
  </div>
);

const WhatsAppLeadModal = ({ open, href, onClose }) => {
  const [form, setForm] = useState(initialState);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onOpenChange = (next) => {
    if (!next) onClose();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.nombre || !form.whatsapp) {
      toast.error("Completa tu nombre y WhatsApp para continuar.");
      return;
    }

    const eventId = crypto.randomUUID();
    window.fbq?.(
      "track",
      "Lead",
      { value: 1, currency: "MXN", lead_type: "whatsapp" },
      { eventID: eventId }
    );

    axios
      .post(
        `${API}/whatsapp-lead`,
        {
          ...form,
          ciudad: form.ciudad || undefined,
          negocio: form.negocio || undefined,
          correo: form.correo || undefined,
          event_id: eventId,
          fbp: getCookie("_fbp"),
          fbc: getCookie("_fbc"),
          event_source_url: window.location.href,
        },
        { headers: { "Content-Type": "application/json" }, timeout: 10000 }
      )
      .catch(() => {});

    const baseMessage = (() => {
      try {
        return new URL(href).searchParams.get("text") || "";
      } catch {
        return "";
      }
    })();
    const detalles = [
      `Nombre: ${form.nombre}`,
      `WhatsApp: ${form.whatsapp}`,
      form.ciudad && `Ciudad: ${form.ciudad}`,
      form.negocio && `Negocio: ${form.negocio}`,
      form.correo && `Correo: ${form.correo}`,
    ]
      .filter(Boolean)
      .join("\n");
    const fullMessage = baseMessage ? `${baseMessage}\n\n${detalles}` : detalles;

    window.open(waUrl(fullMessage), "_blank", "noopener");
    setForm(initialState);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        style={{ background: "var(--ink)", border: "1px solid var(--ink-2)" }}
        className="text-white sm:rounded-[14px]"
      >
        <DialogHeader>
          <p
            className="kicker"
            style={{ color: "var(--red)" }}
            data-testid="whatsapp-modal-kicker"
          >
            WhatsApp
          </p>
          <DialogTitle className="font-display text-white text-[26px] md:text-[30px] leading-none normal-case">
            Cuéntanos un poco de ti
          </DialogTitle>
          <DialogDescription className="text-[#b8b9c1] text-[13px]">
            Con estos datos te atendemos más rápido y con una propuesta pensada
            para tu negocio. Solo toma unos segundos.
          </DialogDescription>
        </DialogHeader>

        <form
          data-testid="whatsapp-lead-form"
          onSubmit={onSubmit}
          className="grid grid-cols-1 gap-3.5 mt-1"
        >
          <Field label="Nombre">
            <div
              className="rounded-[8px]"
              style={{ border: "1px solid var(--ink-2)", background: "#1c1d27" }}
            >
              <input
                required
                data-testid="whatsapp-input-nombre"
                name="nombre"
                value={form.nombre}
                onChange={onChange}
                placeholder="Tu nombre completo"
                className={inputCls}
              />
            </div>
          </Field>
          <Field label="WhatsApp">
            <div
              className="rounded-[8px]"
              style={{ border: "1px solid var(--ink-2)", background: "#1c1d27" }}
            >
              <input
                required
                data-testid="whatsapp-input-whatsapp"
                name="whatsapp"
                value={form.whatsapp}
                onChange={onChange}
                placeholder="Tu número de WhatsApp"
                className={inputCls}
              />
            </div>
          </Field>
          <Field label="Ciudad" optional>
            <div
              className="rounded-[8px]"
              style={{ border: "1px solid var(--ink-2)", background: "#1c1d27" }}
            >
              <input
                data-testid="whatsapp-input-ciudad"
                name="ciudad"
                value={form.ciudad}
                onChange={onChange}
                placeholder="Ciudad donde está tu negocio"
                className={inputCls}
              />
            </div>
          </Field>
          <Field label="Nombre del negocio" optional>
            <div
              className="rounded-[8px]"
              style={{ border: "1px solid var(--ink-2)", background: "#1c1d27" }}
            >
              <input
                data-testid="whatsapp-input-negocio"
                name="negocio"
                value={form.negocio}
                onChange={onChange}
                placeholder="Nombre de tu negocio"
                className={inputCls}
              />
            </div>
          </Field>
          <Field label="Correo electrónico" optional>
            <div
              className="rounded-[8px]"
              style={{ border: "1px solid var(--ink-2)", background: "#1c1d27" }}
            >
              <input
                type="email"
                data-testid="whatsapp-input-correo"
                name="correo"
                value={form.correo}
                onChange={onChange}
                placeholder="tu@correo.com"
                className={inputCls}
              />
            </div>
          </Field>

          <div className="flex gap-3 mt-2">
            <button
              type="button"
              onClick={onClose}
              data-testid="whatsapp-modal-cancel"
              className="bdk-btn bdk-btn--ghost-dark flex-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              data-testid="whatsapp-modal-submit"
              className="bdk-btn bdk-btn--whatsapp flex-1"
            >
              Continuar a WhatsApp
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default WhatsAppLeadModal;
